module.exports = __webpack_public_path__ + "img/fondo_login.07e12833.png";